(function () {
  const clockElem = document.getElementById('footer-clock');
  const yearElem = document.getElementById('footer-current-year');
  let currYear = new Date().getFullYear();

  const update = () => {
    const date = new Date();
    clockElem.textContent = timeFormatter(date);
    const newYear = date.getFullYear();
    if (currYear < newYear) {
      currYear = newYear;
      yearElem.textContent = currYear;
    }
    requestAnimationFrame(update);
  };

  const appendZero = (number) => (number < 10 ? '0' + number : number);

  const timeFormatter = (date) => {
    const hours = appendZero(date.getHours());
    const minutes = appendZero(date.getMinutes());
    const seconds = appendZero(date.getSeconds());

    return `${hours}:${minutes}:${seconds}`;
  };

  yearElem.textContent = currYear;
  update();
})();
